import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import PlayerHealthScores from './playerHealthScores';
import PlayerColumn from './playerColumns';
import PopupRegister from '../../Signup/PopupRegister';
import '../style.css';
import { request } from '../../utils';

function TeamCard(props) {
	const { user, players, sportsName, nbaPage, sources, dispatch } = props;

	const [showModal, setShowModal] = useState(false);
	const [searchString, setSearchString] = useState('');
	const [filteredPlayers, setFilteredPlayers] = useState([]);

	let { sport } = useParams();	
	const nflPage = sport?.toUpperCase() === 'NFL';	
	const soccerPage = sport?.toUpperCase() === 'SOCCER';
	const cricketPage = sport?.toUpperCase() === 'CRICKET';

	// console.log(soccerPage,'soccerPage')
	// Pagination State (for non-cricket pages only)
	const [visiblePlayers, setVisiblePlayers] = useState(50); // initially show 50 players

	useEffect(() => {
		setFilteredPlayers(players);
	}, [players]);

	// Infinite scrolling logic (only for non-cricket views; cricket uses server-side cursor pagination)
	const loadMorePlayers = () => {
		if (visiblePlayers < filteredPlayers.length) {
			setVisiblePlayers((prevVisible) => prevVisible + 50); // Load 50 more players
		}
	};

	// Handle scroll event to detect when user reaches the bottom (disabled for cricket)
	useEffect(() => {
		if (cricketPage) return; // cricket uses cursor-based pagination in UpcomingGames

		const handleScroll = () => {
			const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			const windowHeight = window.innerHeight;
			const docHeight = document.documentElement.scrollHeight;
	
			// If the user has scrolled to the bottom of the document
			if (scrollTop + windowHeight >= docHeight) {
				loadMorePlayers(); // Load more players when bottom is reached
			}
		};
		
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [visiblePlayers, filteredPlayers, cricketPage]);

	// Handle search filter: first try local data, if nothing found then hit the backend
	useEffect(() => {
		if (!searchString) {
			setFilteredPlayers(players);
			if (!cricketPage) {
				setVisiblePlayers(50);
			}
			return;
		}

		const localResult = players?.filter((player) =>
			player.player_name.toLowerCase().includes(searchString.toLowerCase())
		);

		if (localResult && localResult.length > 0) {
			setFilteredPlayers(localResult);
			if (!cricketPage) {
				setVisiblePlayers(50);
			}
			return;
		}

		// no local hit, query server
		(async () => {
			try {
				let url;
				if (cricketPage) {
					url = `/api/cricket/players?league=${sportsName || 'IPL'}&search=${encodeURIComponent(
						searchString
					)}`;
				} else {
					url = `/main/players/${user.sportsID || 1}?league=${user?.league}&search=${encodeURIComponent(
						searchString
					)}`;
				}
				const res = await request({}, url, 'GET', user?.token);
				const data =
					res?.data?.data?.playerInfo || res?.data?.data?.players || [];
				const list = Array.isArray(data) ? data : [];
				setFilteredPlayers(list);
				if (!cricketPage) {
					setVisiblePlayers(50);
				}
			} catch (err) {
				console.error('player search error', err);
				setFilteredPlayers([]);
				if (!cricketPage) {
					setVisiblePlayers(50);
				}
			}
		})();
	}, [searchString, players]);

	const handleLinkClick = (e) => {
		if (!user?.login && (nflPage || nbaPage || soccerPage)) {
			e.preventDefault();
			setShowModal(true);
		}
		 else if (user?.login && !user?.email_verified && (nflPage || nbaPage || soccerPage)) {
			e.preventDefault();
			setShowModal(true);
		}
	};

	return (
		<React.Fragment>
			<PopupRegister 
				showModal={showModal} 
				setShowModal={setShowModal} 
				returnUrl={window.location.pathname + window.location.search}
			/>
			<div className='searchBox'>
				<input
					type='text'
					placeholder='Search players...'
					onChange={(e) => setSearchString(e.target.value)}
					className='playerSearchInput'
				/>
			</div>

			{/* Render visible players only (for cricket, show all fetched players; for others, use local pagination) */}
			{filteredPlayers && (cricketPage ? filteredPlayers : filteredPlayers.slice(0, visiblePlayers)).map((player, i) => (
				<Col
					id={player.team_id}
					lg={4}
					key={i}
					className='cardCol col-xl-5ths col-md-6 col-sm-6 col-xs-12'
					style={{ height: '300px' }}
				>
					<div className='cardColDiv'>
						<Col lg={12} className='cardViewGameCol'>
							<>
								{user?.login ? <PlayerHealthScores player={player} sportsName={sportsName} /> : <div style={{ padding: '27.5px 0' }} />}
							</>
							<PlayerColumn player={player} userAllowed={user?.login} sportsID={user?.sportsID} />
							<Link
								className='cardViewGameButton hover-delay'
								title='View Player'
								to={{
									pathname: cricketPage
										? `/cricket/ipl/player/${player.master_player_id}`
										: `/${sportsName || 'ipl'}/player/${player.player_id}`
								}}
								onClick={handleLinkClick}
							>
								{user?.login ? 'View Player' : 'LOG IN OR JOIN FOR FREE'}
								{/* {(user?.login || (!user?.login && i == 0)) ? 'VIEW MATCHUP' : 'LOG IN OR JOIN FOR FREE'} */}
							</Link>
						</Col>
					</div>
				</Col>
			))}
		</React.Fragment>
	);
}

const mapStateToProps = (state) => ({
	isLoading: state.isLoading,
	isLoaded: state.isLoaded,
	schedules: state.schedules,
	match: state.match,
	user: state.user,
	purchasePlan: state.purchasePlan,
	sources: state.source
});

export default connect(mapStateToProps)(TeamCard);
